module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header'), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_vm._v("\n            \n        ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "10"
    }
  }, [_c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('label', {
    staticStyle: {
      "font-family": "inherit",
      "font-size": "large"
    }
  }, [_vm._v("Create A New Project")])]), _vm._v(" "), _c('Form', {
    ref: "formValidate",
    staticStyle: {
      "margin-top": "40px"
    },
    attrs: {
      "model": _vm.formValidate,
      "label-position": "left",
      "rules": _vm.ruleValidate,
      "label-width": 100
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "Name",
      "prop": "projectName"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "Enter project name",
      "clearable": ""
    },
    model: {
      value: (_vm.formValidate.projectName),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "projectName", $$v)
      },
      expression: "formValidate.projectName"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "Description",
      "prop": "projectDesc"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 5
      },
      "placeholder": "Enter something..."
    },
    model: {
      value: (_vm.formValidate.projectDesc),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "projectDesc", $$v)
      },
      expression: "formValidate.projectDesc"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "contacts",
      "prop": "contacts"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "Enter contacts",
      "clearable": ""
    },
    model: {
      value: (_vm.formValidate.contacts),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "contacts", $$v)
      },
      expression: "formValidate.contacts"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "E-mail",
      "prop": "contactEmail"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "Enter your e-mail",
      "clearable": ""
    },
    model: {
      value: (_vm.formValidate.contactEmail),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "contactEmail", $$v)
      },
      expression: "formValidate.contactEmail"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "Financing",
      "prop": "financingTarget"
    }
  }, [_c('InputNumber', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "max": 100000000,
      "min": 0
    },
    model: {
      value: (_vm.financingTarget),
      callback: function($$v) {
        _vm.financingTarget = $$v
      },
      expression: "financingTarget"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "White Paper",
      "prop": "whitePaper"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "Enter the white paper link",
      "clearable": ""
    },
    model: {
      value: (_vm.formValidate.whitePaper),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "whitePaper", $$v)
      },
      expression: "formValidate.whitePaper"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "Telegram",
      "prop": "telegram"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "Enter telegram link",
      "clearable": ""
    },
    model: {
      value: (_vm.formValidate.telegram),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "telegram", $$v)
      },
      expression: "formValidate.telegram"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "Twitter",
      "prop": "twitter"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "Enter Twitter account",
      "clearable": ""
    },
    model: {
      value: (_vm.formValidate.twitter),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "twitter", $$v)
      },
      expression: "formValidate.twitter"
    }
  })], 1), _vm._v(" "), _c('FormItem', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit('formValidate')
      }
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    on: {
      "click": function($event) {
        return _vm.handleReset('formValidate')
      }
    }
  }, [_vm._v("Reset")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', [_vm._v("\n                 \n            ")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13b5c6f5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/project/CreateProject.vue
// module id = 416
// module chunks = 0